module.exports = __webpack_public_path__ + "static/media/team.716bd37a.jpg";